import { Paper, Stack } from '@mui/material';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { memo } from 'react';
import { stockQuantityService } from 'services/api';

const StockQuantitiesDetail = ({ row: rowProp, columns: columns, isDir }: any) => {
  const params: Record<string, unknown> = {
    product__id: rowProp.product__id
  };
  if (rowProp.warehouse__id != null && rowProp.warehouse__id !== undefined) {
    params.warehouse__id = rowProp.warehouse__id;
  }

  // Dettaglio: sempre "distinct per location" (come tabella Giacenza lotti), filtrato per product [e opz. warehouse]
  const detailColumns = columns.map((col: any) => ({
    ...col,
    filterable: false,
    sortable: false,
    editable: !isDir
  }));

  return (
    <Stack sx={{ py: 2, height: '100%', boxSizing: 'border-box' }} direction="column">
      <Paper sx={{ flex: 1, mx: 'auto', width: '95%', p: 1 }}>
        <Stack direction="column" spacing={1} sx={{ height: 1 }}>
          <EnhancedDataGrid
            columns={detailColumns}
            service={stockQuantityService}
            getMethod={stockQuantityService.getStockQuantityWithLocation}
            outerParams={params}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default memo(StockQuantitiesDetail);
